<template>
    <div class="login-wrap" >
		<div class="ms-login-bg"></div>
        <div class="ms-login" >
			<img src="../../assets/img/common/logoIcon.png" alt="" class="loginImg">
            <el-form class="ms-content" ref="registerRule" :label-width="index==1?'80px':'0'" :model="form" :rules="rules" label-position="left">
				<div v-if="index == 0" >
					<el-form-item prop="phone"  >
					    <el-input v-model="form.phone" placeholder="请输入手机号">
					        <i slot="prepend" class="iconfont icon-shouji1"></i>
					    </el-input>
					</el-form-item>
					<el-form-item prop="code"  class="code">
					    <el-input v-model="form.code" placeholder="请输入验证码">
					        <i slot="prepend" class="iconfont icon-icon"></i>
					    </el-input>
						 <span @click="getCode" v-if="count == 0">获取验证码</span>
						 <span v-else>{{count}}秒后重发</span>
					</el-form-item>
				</div>
                <div v-if="index == 1">
					<el-form-item prop="newPassword" label="新密码" >
					    <el-input type="password" placeholder="输入您的密码" v-model="form.newPassword" ></el-input>
					</el-form-item>
					<el-form-item prop="affirmPassword"  label="确认密码" >
					    <el-input type="password" placeholder="二次输入密码" v-model="form.affirmPassword" ></el-input>
					</el-form-item>
				</div>
            </el-form>
			<div class="login-btn">
			    <el-button type="primary"  v-if="index == 0"  @click="onSubmit(1)" >安全校验</el-button>
				<el-button type="primary"  v-if="index == 1"  @click="onSubmit(0)">去登录</el-button>
			</div>
			
        </div>
    </div>
</template>

<script>
import mainApi from "network/mainApi";
import { mapMutations } from 'vuex'
export default {
    data() {
        return {
			index:0,
			appid: '',
			count:"",
            form: {
				phone:"",
                code: "",
				newPassword:"",
				affirmPassword: "",
            },
            rules: {
                phone: [
                    { required: true, message: "请输入手机号",trigger: "blur"},
                ],
                code: [
                    { required: true, message: "请输入验证码", trigger: "blur" },
                ],
				newPassword: [
				    { required: true, message: "请输入新密码", trigger: "blur" },
				],
				affirmPassword: [
				    { required: true, message: "二次输入密码", trigger: "blur" },
				],
            },
            loadStatus: false, //请求时的loading效果
        };
    },
    methods: {
        ...mapMutations(['setState']),
       // 获取验证码
       getCode(){
       	let time_count = 60; //60秒
       	if(!this.timer){
       		this.count = time_count;
       		this.timer  = setInterval(res=>{
       			if(this.count>0&&this.count<=time_count){
       				this.count--;
       			}else{
       				clearInterval(this.timer);
       				this.timer = null;
       			}
       		},1000)
       	}
       	
       },
	   onSubmit(i){
		   this.$refs['registerRule'].validate((valid) => {
		       if (valid) {
		            this.index = i;
		       }
		   });
	   }
		
    },
};
</script>

<style scoped lang='scss'>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
	background-image: url(../../assets/img/common/bg1.jpg);
	background-size:100% 100% ;
	.ms-login-bg,.ms-login{
		position: absolute;
		left: 50%;
		top: 50%;
		width: 350Px;
		height:280Px;
		border-radius: 4PX;
		transform: translate(-50%,-50%);
		
	}
	.ms-login {
	    background: rgba(255, 255, 255, 0.9);
		.loginImg{
			width: 65PX;
			height: 65PX;
			margin: 15PX auto;
			display: block;
		}
		.ms-header {
			display: flex;
			width: 100%;
			line-height: 30PX;
			height: 60PX;
			padding: 15PX 0;
			box-sizing: border-box;
			li{
				flex: 1;
				font-size: 16PX;
				color: #3c3c3c;
				text-align: center;
				cursor:pointer;
				&:last-child{
					border-left: 2PX solid #cdcfcf;
				}
			}
			.active{
				font-weight: bolder;
			}
		}
		.ms-content {
		    padding: 0PX 30PX 0PX 30PX;
			/deep/ .el-form-item{
				margin-bottom: 20PX;
				.iconfont{
					font-size: 20PX;
				}
				.el-input__inner{
					height: 42PX;
					line-height: 42PX;
					padding-right: 90PX;
					&::-webkit-input-placeholder {
					    /* placeholder颜色 */
					    color: #aab2bd;
					    /* placeholder字体大小 */
					    font-size: 13PX;
					}
				}
				.el-input-group__prepend{
					width: 42PX;
					padding: 0;
					text-align: center;
				}
			}
			.code{
				position: relative;
				span{
					position: absolute;
					line-height: 42PX;
					right:0;
					top: 0;
					padding: 0 10PX;
					cursor: pointer;
				}
			}
			/* 统一登陆样式 */
			.login-other { 
			    font-size: 13PX;
			    height: 30PX;
			    display: flex;
			    align-items: center;
			    color: #6c6c6c;
			    i {
			        font-size: 30PX;
			        color: #eb7644;
					margin-right: 10PX;
			    }
			}
			.other-links{
				display: flex;
				font-size: 12PX;
				color: #6c6c6c;
				line-height: 50PX;
				justify-content: flex-end;
				li{
					padding-left: 10PX;
					cursor: pointer;
				}
			}
		}
		.login-btn {
			padding: 0PX 30PX 0PX 30PX;
			button {
			    width: 100%;
			    height: 38PX;
				font-size: 16PX;
			}
		}
	}
}
</style>
